<div class="w-3/5 m-auto h-10 mt-5 mb-5 text-base">
    <a href="https://bit.ly/45LsKTf" target="_blank"
        class="font-medium text-blue-600 dark:text-blue-500 hover:underline">Terms & Conditions</a> <br />
    <a href="https://bit.ly/3CwfYLb" target="_blank"
        class="font-medium text-blue-600 dark:text-blue-500 hover:underline">Privacy Policy</a>
</div>